// react
import { Suspense } from 'react';

// tanstack
import { createFileRoute, Outlet } from '@tanstack/react-router';

function UserLayout() {
  return (
    <Suspense>
      <Outlet />
    </Suspense>
  );
}

export const Route = createFileRoute('/$accountId/_user')({
  component: UserLayout,
});
